/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 08.05.2015
 *   Time: 18:11
 */

import { IFormat } from "../api/IFormat";
import { ILocaProcessor } from "../../processors/api/ILocaProcessor";
import { Time } from "../../utils/time/Time";
import { TimeType } from "../../utils/time/TimeType";
import { InlineDurationFormat } from "./InlineDurationFormat";
import { DurationFormatUtils } from "./DurationFormatUtils";

/**
 * @private
 */
export class SimpleDurationFormat implements IFormat {
    private _processor: ILocaProcessor;
    private _inlineDurationFormat: InlineDurationFormat;
    protected static bestRounding(template) {
        let roundTo = TimeType.MILLISECONDS;
        DurationFormatUtils.forAllPlaceholders(template, name => {
            const type = TimeType.getByName(name);
            if (type && type.milliseconds > roundTo.milliseconds) {
                roundTo = type;
            }
        });
        return roundTo;
    }

    constructor(processor: ILocaProcessor) {
        this._processor = processor;
        this._inlineDurationFormat = new InlineDurationFormat();
    }

    public apply(template: string, seconds: number, roundTo: TimeType = null): string {
        let result: string = this._processor.text(template);

        roundTo = roundTo || SimpleDurationFormat.bestRounding(result);

        const time = new Time(seconds, TimeType.SECONDS, roundTo).toVector();
        const textFn = this._processor.text.bind(this._processor);
        return DurationFormatUtils.replacePlaceholders(result, (name, format) => {
            const index = DurationFormatUtils.timeTypeNames.indexOf(name);
            const formatter = this._inlineDurationFormat.parse(format);
            return formatter.apply(textFn, time, index);
        });
    }
}
